// ═══════════════════════════════════════════════════════════════════════════
// 💊 FILTER PILLS - Pills stile Big Tech per filtri categoria
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';

/**
 * Pills per filtrare per categoria
 * Stile identico alla vista Foto esistente
 *
 * @param {Object} categories - Oggetto { "Categoria": count, ... }
 * @param {string} selected - Categoria selezionata ('all' o nome categoria)
 * @param {function} onChange - Callback quando cambia selezione
 */
function FilterPills({ categories, selected, onChange }) {
  // Calcola totale
  const total = Object.values(categories).reduce((a, b) => a + b, 0);

  return (
    <div style={styles.container}>
      {/* Pill "Tutte" sempre prima */}
      <button
        style={selected === 'all' ? styles.pillActive : styles.pill}
        onClick={() => onChange('all')}
      >
        Tutte ({total})
      </button>

      {/* Pill per ogni categoria */}
      {Object.entries(categories)
        .sort(([a], [b]) => a.localeCompare(b)) // Ordine alfabetico
        .map(([cat, count]) => (
          <button
            key={cat}
            style={selected === cat ? styles.pillActive : styles.pill}
            onClick={() => onChange(cat)}
          >
            {cat} ({count})
          </button>
        ))}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// 🎨 STYLES - Big Tech Minimal Design
// ═══════════════════════════════════════════════════════════════════════════

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginBottom: '24px',
  },

  pill: {
    padding: '8px 16px',
    borderRadius: '9999px', // Full rounded
    border: '1px solid #E5E5E5',
    background: '#FFFFFF',
    color: '#525252',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    cursor: 'pointer',
    transition: 'all 200ms ease',
    outline: 'none',
    whiteSpace: 'nowrap',
  },

  pillActive: {
    padding: '8px 16px',
    borderRadius: '9999px',
    border: 'none',
    background: '#22C55E',
    color: '#FFFFFF',
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    cursor: 'pointer',
    transition: 'all 200ms ease',
    outline: 'none',
    whiteSpace: 'nowrap',
    boxShadow: '0 1px 3px rgba(34, 197, 94, 0.3)',
  },
};

export default FilterPills;
